module.exports = __webpack_public_path__ + "static/media/check.58563fe5.svg";